module.exports = __webpack_public_path__ + "static/Background_hero_home-e43f758dc3083cf99bd127473402d654.jpg";